/**
 * WordPress dependencies
 */
const { Component, Fragment } = wp.element;
const { __ } = wp.i18n;

import Tooltip from '../components/Tooltips';
import MappingValueField from '../components/MppingValueField';

export default class Mapping extends Component {

	renderRequiredSpan() {
		const choice = this.props.choice;
		const fieldId = this.getKeyInputId();

		if ( choice.required ) {
			return <span className="required" id={ fieldId }>*</span>
		} else {
			return null;
		}
	}

	render() {
		const { isInvalid, index } = this.props;

		return (
			<tr className="gform-settings-generic-map__row">
				<td className="gform-settings-generic-map__column gform-settings-generic-map__column--key">
					{ this.getKeyInput( index ) }
				</td>
				<td className="gform-settings-generic-map__column gform-settings-generic-map__column--value">
					{ this.getValueInput() }
				</td>
				<td className="gform-settings-generic-map__column gform-settings-generic-map__column--error">
					{
						isInvalid && <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11 22C4.9249 22 0 17.0751 0 11S4.9249 0 11 0s11 4.9249 11 11-4.9249 11-11 11z" fill="#E54C3B"/>
							<path fillRule="evenodd" clipRule="evenodd" d="M9.9317 5.0769a.1911.1911 0 00-.1909.2006l.3708 7.4158a.8895.8895 0 001.7768 0l.3708-7.4158a.1911.1911 0 00-.1909-.2006H9.9317zm2.3375 10.5769c0 .701-.5682 1.2693-1.2692 1.2693-.701 0-1.2692-.5683-1.2692-1.2693 0-.7009.5682-1.2692 1.2692-1.2692.701 0 1.2692.5683 1.2692 1.2692z" fill="#fff"/>
						</svg>
					}
				</td>
				<td className="gform-settings-generic-map__column gform-settings-generic-map__column--buttons">
					{ this.getAddButton() }
					{ this.getDeleteButton() }
				</td>
			</tr>
		)

	}

	getValueInputId() {
		const { inputId, inputType, index, mapping } = this.props;

		switch( inputType ) {
			case 'generic_map':
			case 'dynamic_field_map':
				return `${inputId}_custom_value_${index}`;
			default:
				return `${inputId}_${mapping.key}`;
		}
	}

	getKeyInputId() {
		const { inputId, inputType, index, mapping } = this.props;

		switch( inputType ) {
			case 'generic_map':
			case 'dynamic_field_map':
				return `${inputId}_custom_key_${index}`;
			default:
				return `${inputId}_${mapping.key}_key`;
		}
	}


	// # KEY COLUMN ----------------------------------------------------------------------------------------------------

	/**
	 * Prepare input for key column.
	 * If choice is required, returns only text.
	 *
	 * @returns {*}
	 */
	getKeyInput( mapIndex ) {
		const { choice, keyField, index, mapping, updateMapping } = this.props;
		const { choices, display_all, placeholder } = keyField;

		const fieldId = this.getKeyInputId();

		// If currently selected choice is required or we are displaying all keys, display label.
		if ( choice.required || display_all ) {
			return <Fragment><label>{ choice.label } { this.renderRequiredSpan() } </label><Tooltip tooltip={ choice.tooltip }></Tooltip></Fragment>
		}

		// If selected choice is custom key, display input.
		if ( mapping.key === 'gf_custom' ) {

			return (
				<span className="gform-settings-generic-map__custom">
					<input id={ fieldId } type="text" value={ mapping.custom_key } placeholder={ placeholder } onChange={ ( e ) => updateMapping( { ...mapping, custom_key: e.target.value }, index ) } />
					{
						choices.length > 0 && <button className="gform-settings-generic-map__reset" onClick={ ( e ) => { e.preventDefault(); updateMapping( { ...mapping, key: '', custom_key: '' }, index ); } }>
							<span className="screen-reader-text">{ __( 'Remove Custom Key', 'gravityforms' ) }</span>
						</button>
					}
				</span>
			);

		}

		return (
			<select
				id={ fieldId }
				value={ mapping.key }
				onChange={ ( e ) => updateMapping( { ...mapping, key: e.target.value }, index ) }
			>
				{ this.getKeyOptions( mapIndex ) }
			</select>
		);

	}

	/**
	 * Get options for key drop down.
	 *
	 * @since 2.5
	 *
	 * @param {integer} mapIndex       Index of current mapping object.
	 * @param {array}   choices        Choices to build options from.
	 * @param {boolean} addPlaceholder Include the "Select a Field" choice.
	 * @param {boolean} addCustomKey   Include the "Add Custom Key" choice.
	 *
	 * @returns {{label: string, value: string, disabled: boolean}[]}
	 */
	getKeyOptions( mapIndex, choices = false, addPlaceholder = true, addCustomKey = true ) {

		const { keyField, mappedChoices, mapping } = this.props;
		const { allow_custom, allow_duplicates } = keyField;

		if ( ! choices ) {
			choices = keyField.choices;
		}

		const choiceNames = choices.map( ( c ) => c.name || c.value );
		const optionKeyBase = `select-${ mapIndex }-optiongroup-`;

		// Initialize options array.
		let options = [];
		if ( ! choiceNames.includes( '' ) && addPlaceholder ) {
			options.push(
				(
					<option
						key={ `${ optionKeyBase }-default` }
						value=""
						disabled={ false }
					>
						{ __( 'Select a Field', 'gravityforms' ) }
					</option>
				)
			);
		}

		// Loop through choices, add as options.
		for ( let i = 0; i < choices.length; i++ ) {

			let choice = choices[ i ],
				choice_value = choice.name || choice.value;

			// If this is a required choice, do not add as an option.
			if ( choice.required ) {
				continue;
			}

			// If choice is already selected, disable it.
			let disabled = mappedChoices.includes( choice_value ) && choice_value !== mapping.key && ! allow_duplicates;

			// Add optgroups for choices with sub-choices.
			if ( choice.choices && choice.choices.length > 0 ) {

				options.push(
					(
						<optgroup
							label={ choice.label }
							key={ `${ optionKeyBase }-${ i }` }
						>
							{ this.getKeyOptions( `${ mapIndex }.${ i }`, choice.choices, false, false ) }
						</optgroup>
					)
				);

			}  else {

				options.push(
					(
						<option
							key={ `${ optionKeyBase }-${ i }` }
							value={ choice.value }
							disabled={ disabled }
						>
							{ choice.label }
						</option>
					)
				);

			}

		}

		// Add custom key if enabled and is not already present.
		if ( allow_custom && ! choiceNames.includes( 'gf_custom' ) && addCustomKey ) {
			options.push(
				(
					<option
						key={ `${ optionKeyBase }-custom` }
						value="gf_custom"
						disabled={ false }
					>
						{ __( 'Add Custom Key', 'gravityforms' ) }
					</option>
				)
			);
		}

		return options;

	}


	// # VALUE COLUMN --------------------------------------------------------------------------------------------------

	/**
	 * Prepare input for value column.
	 *
	 * @returns {*}
	 */
	getValueInput() {

		const { choice, index, isInvalid, mapping, updateMapping, valueField, mergeTagSupport } = this.props;

		const required = choice.required;
		const fieldId  = this.getValueInputId();

		// If selected value is custom value, display input.
		if ( mapping.value === 'gf_custom' ) {
			return ( <MappingValueField choice={choice} index={index} isInvalid={isInvalid} mapping={mapping} updateMapping={updateMapping} valueField={valueField} mergeTagSupport={mergeTagSupport} fieldId={ fieldId }> </MappingValueField> );
		}

		return (
			<select
				id={ fieldId }
				disabled={ mapping.key === '' || ! mapping.key }
				value={ mapping.value }
				onChange={ ( e ) => updateMapping( { ...mapping, value: e.target.value }, index ) }
				className={ isInvalid ? 'gform-settings-generic-map__value--invalid' : '' }
				required={ required }
			>
				{
					this.getValueOptions().map(
						( opt ) => {
							if ( opt.choices && opt.choices.length > 0 ) {
								return (
									<optgroup key={ opt.label } label={ opt.label }>
										{ opt.choices.map( ( o ) => <option key={ o.value } value={ o.value }>{ o.label }</option> ) }
									</optgroup>
								);
							} else {
								return ( <option key={ opt.value } value={ opt.value }>{ opt.label }</option> );
							}
						}
					)
				}
			</select>
		);

	}

	/**
	 * Get options for value drop down.
	 *
	 * @returns {{label: *, value: boolean}[]}
	 */
	getValueOptions() {
		const { choice, valueField } = this.props;
		const { allow_custom }       = valueField;
		const choiceName             = ( choice.name && valueField.choices[ choice.name ] ) ? choice.name : 'default'; // if no name is present, use default values.

		let choices = choice.choices || valueField.choices[ choiceName ];

		// Safety check to ensure choices are an array.
		if ( ! choices ) {
			choices = [];
		}

		let values = choices.map( ( c ) => c.value );

		// Add custom key if enabled and is not already present.
		if ( allow_custom && ! values.includes( 'gf_custom' ) ) {
			choices.push(
				{
					label:    __( 'Add Custom Value', 'gravityforms' ),
					value:    'gf_custom',
					disabled: false,
				}
			);
		}

		return choices;

	}





	// # BUTTONS -------------------------------------------------------------------------------------------------------

	/**
	 * Get add mapping button.
	 *
	 * @returns {null|*}
	 */
	getAddButton() {

		const { canAdd, addMapping, index } = this.props;

		// If mapping cannot be added, do not show button.
		if ( ! canAdd ) {
			return null;
		}

		return <button className="add_field_choice gform-st-icon gform-st-icon--circle-plus gform-settings-generic-map__button gform-settings-generic-map__button--add" onClick={ ( e ) => { e.preventDefault(); addMapping( index ); } }>
			<span className="screen-reader-text">{ __( 'Add', 'gravityforms' ) }</span>
		</button>

	}

	/**
	 * Get delete mapping button.
	 *
	 * @returns {null|*}
	 */
	getDeleteButton() {

		const { canDelete, deleteMapping, index } = this.props;

		// If mapping cannot be deleted, do not show button.
		if ( ! canDelete ) {
			return null;
		}

		return <button className="delete_field_choice gform-st-icon gform-st-icon--circle-minus gform-settings-generic-map__button gform-settings-generic-map__button--delete" onClick={ ( e ) => { e.preventDefault(); deleteMapping( index ); } }>
			<span className="screen-reader-text">{ __( 'Delete', 'gravityforms' ) }</span>
		</button>

	}

}
